import styled from 'styled-components';
import { MAX_MOBILE_WIDTH } from '../../../../utils/constants';

export const MoreInfoTableContainer = styled.article`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    margin-top: 24px;
    margin-left: 16px;
    margin-bottom: 36px;
  }
`;

export const MoreInfoTableHeading = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    font-size: 14px;
    font-weight: 600;
  }
`;

export const MoreInfoTableDescription = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 33px;
`;

export const MoreInfoTableAttrElement = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  border-bottom: 1px solid #e9e9e9;
  width: 250px;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    width: 148px;
  }
`;

export const MoreInfoTableAttrElementHeading = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  color: #999999;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 8px;
  margin-top: 8px;
  width: auto;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    font-size: 12px;
    width: 40vw;
  }
`;

export const MoreInfoTableAttrElementInfo = styled.span`
  width: 10vw;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #414141;
  font-weight: 600;
  font-size: 14px;
  width: auto;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    width: 40vw;
  }
`;
